import { API_PATH } from "src/const/api-urls";
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env";
import { BaseResponse } from "src/interface";
import { createCreDtTm, createMSGID } from "src/utils/helper";
import httpsService from "./httpsService";



export const getTokenCardByAccountId = (frSystm: string, accountId :string) => {
  return httpsService.get<null, BaseResponse<any>>(API_PATH.TOKEN_CARD, {
    headers: { creDtTm: createCreDtTm(), frSystm: frSystm, toSystm: TO_HEADER},
    params: { msgId: createMSGID(frSystm), accountId : accountId },
  });
};
export const deleteTokenCardById = (frSystm: string, id : number) => {
  return httpsService.get<null, BaseResponse<any>>(API_PATH.TOKEN_CARD_DELETE, {
    headers: { creDtTm: createCreDtTm(), frSystm: frSystm, toSystm: TO_HEADER},
    params: { msgId: createMSGID(frSystm), id : id },
  });
};
